import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthInfoContext = /*#__PURE__*/createContext(undefined);
export const AuthInfoProvider = ({
  authInfo,
  children
}) => {
  return /*#__PURE__*/_jsx(AuthInfoContext.Provider, {
    value: authInfo,
    children: children
  });
};
export function useAuthInfoProvider() {
  const context = useContext(AuthInfoContext);
  if (context === undefined) {
    throw new Error('useAuthInfoProvider must be used within a AuthInfoProvider');
  }
  return {
    userInfo: context.userInfo,
    portalScopes: context.portalScopes || []
  };
}